'use strict';

const numeral = require('numeral');
module.exports.capitalize = function (string) {
  let str = String(string || '');
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};
module.exports.getSpacedPhoneNumber = function (phone_number) {
  let returned_str = '';
  phone_number = String(phone_number || '');
  phone_number = phone_number.split(' ').join('');
  if (phone_number.indexOf('+33') === 0) {
    phone_number = phone_number.substring(3);
    phone_number = '0' + phone_number;
  } else if (phone_number.indexOf('33') === 0) {
    phone_number = phone_number.substring(2);
    phone_number = '0' + phone_number;
  }
  for (let i = 0; i < phone_number.length; i++) {
    if (i > 0 && i % 2 === 0) {
      returned_str += ' ';
    }
    returned_str += phone_number[i];
  }
  return returned_str;
};
const allowed_values = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
module.exports.cleanNumber = function (_ref) {
  let {
    number = '',
    positive,
    int,
    digits,
    max
  } = _ref;
  if (typeof number === 'number') {
    number = String(number);
  } else if (typeof number !== 'string') {
    return '0';
  }
  const allowed = allowed_values.slice(0);
  if (!positive) allowed.push('-');
  if (!int) {
    allowed.push(',');
    allowed.push('.');
  }
  const value = Array.from(number || '').filter(letter => allowed.includes(letter)).join('').split(',').join('.').split('.');
  let safe_value = value[0] || '';
  if (value.length > 1) {
    const digits_str = value[1] + value.slice(2).join('');
    safe_value += '.' + (digits ? digits_str.slice(0, parseInt(digits)) : digits_str);
  }
  if (safe_value === '.') {
    safe_value = '0.';
  }
  if (safe_value && Array.from(safe_value).every(char => char === '0')) {
    return '0';
  }
  if (max) {
    const val = module.exports.safeNumeral(safe_value);
    if (numeral(val).value() > max) return max;
  }
  return safe_value;
};
module.exports.safeNumeral = function () {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof value === 'number') value = String(value);
  let safe_value = module.exports.cleanNumber({
    number: value
  });
  if (safe_value.startsWith('.')) {
    safe_value = '0' + safe_value;
  }
  if (safe_value.endsWith('.')) {
    safe_value = safe_value.slice(0, safe_value.length - 1);
  }
  if (value && isNaN(parseFloat(safe_value))) {
    console.log('NaN', safe_value);
    return '0';
  }
  return safe_value || '0';
};
module.exports.i18nField = function () {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let field = arguments.length > 1 ? arguments[1] : undefined;
  let lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'FR';
  return data[field + '_' + lang.toUpperCase()] || data[field];
};
module.exports.formatNum = function (number) {
  let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0,0[.]00';
  return numeral(module.exports.safeNumeral(number)).format(format).split(',').join(' ');
};
module.exports.num = function (number) {
  let digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return Number(numeral(module.exports.safeNumeral(number)).value().toFixed(digits));
};
module.exports.isTrue = function (value) {
  return [true, 'true'].includes(value);
};
module.exports.isFalse = function (value) {
  return [false, 'false'].includes(value);
};
module.exports.getUrlParameter = function (name, custom_str) {
  let search = typeof custom_str !== 'undefined' ? custom_str.split('&') : document.location.search.split('&');
  if (search[0]) {
    search[0] = search[0].replace('?', '');
  }
  const slug = search.find(slug => slug.startsWith(name + '='));
  if (typeof slug === 'undefined') return undefined;
  return decodeURI(slug.slice((name + '=').length));
};

/**
 * @version 1.0.0
 *
 * @param { String } MIME file type, as per @see MDN.
 *
 * @returns { String } start of MIME type string (application, image, etc.)
**/
module.exports.getTypeFromMIME = function (MIME) {
  if (MIME.startsWith('application/pdf')) return 'pdf';
  return MIME.slice(0, MIME.indexOf('/'));
};
